module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/8-878db6c547f8193a7efbfe22111bd007.jpg";